export * from './deviation-type.module';
